import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import { FormikProps } from "formik";
import React, { useEffect, useState } from "react";
import styled from "styled-components";

import { Button, StyledGrid, TextField } from "components/simple";
import { StyledForgotPasswordLink } from "./styled";

interface FormValues {
  email: string;
  password: string;
}

type FormProps = FormikProps<FormValues>;

const StyledForm = styled.form`
  margin-top: 30px;
  && > div {
    margin-bottom: 20px;
  }
`;

const Form: React.FC<FormProps> = (props: FormProps) => {
  const {
    values: { email, password },
    handleBlur,
    handleChange,
    handleSubmit,
    errors,
    isValid,
    isSubmitting,
    setFieldValue
  } = props;

  const savedEmail = localStorage.getItem("email");
  const [rememberMe, setRememberMe] = useState(savedEmail ? true : false);

  useEffect(() => {
    if (savedEmail) setFieldValue("email", savedEmail);
  }, []); // eslint-disable-line

  return (
    <StyledForm
      onSubmit={e => {
        if (rememberMe) localStorage.setItem("email", email);
        else localStorage.removeItem("email");
        handleSubmit(e);
      }}
    >
      <Grid container direction="column">
        <Grid item>
          <TextField
            id="email-input"
            error={!!errors.email}
            fullWidth
            helperText={errors.email}
            label="Email"
            name="email"
            onBlur={handleBlur}
            onChange={handleChange}
            required
            value={email}
          />
        </Grid>
        <Grid item>
          <TextField
            id="password-input"
            fullWidth
            label="Password"
            name="password"
            onBlur={handleBlur}
            onChange={handleChange}
            required
            type="password"
            value={password}
          />
        </Grid>
        <StyledGrid item textAlign="end">
          <StyledForgotPasswordLink to="/forgot_password">
            Forgot Password?
          </StyledForgotPasswordLink>
        </StyledGrid>
        <Grid item xs>
          <FormControlLabel
            control={
              <Checkbox
                name="rememberMe"
                checked={rememberMe}
                onChange={() => {
                  setRememberMe(!rememberMe);
                }}
              />
            }
            label="Remember Me"
          />
        </Grid>
        <StyledGrid item md={5} xs={12} marginTop="10px">
          <Button disabled={!isValid || isSubmitting} fullWidth longText type="submit">
            Sign In
          </Button>
        </StyledGrid>
      </Grid>
    </StyledForm>
  );
};

export default Form;
